class Glossary {

    constructor(element) {
      let term = element.getAttribute('data-term');
      let lang = element.getAttribute('data-term-lang');
      Glossary.fetchTerm(term, lang);
      console.log(term);
    }
  
    static async fetchTerm(term, lang) {
      try {
        // Perform the fetch request
        const response = await fetch(`/${lang}/glossary/${term}`, {
            headers: {
                'Accept': 'text/html'
            }
        });
        
        // Check if the request was successful
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        
        // Call the static method to handle the response
        Glossary.displayTerm(response);
      } catch (error) {
        console.error('Error fetching term:', error);
      }
    }
  
    static async displayTerm(response) {
      try {
        // Parse JSON response
        const data = await response.json();
        
        // Handle the data (implement your logic here)
        
        document.querySelector('#glossaryModal .modal-title').innerHTML = data['term'];
        document.querySelector('#glossaryModal .modal-body').innerHTML = data['definition'];
    
        let glossaryModal = document.getElementById('glossaryModal');
        var bsModal = new bootstrap.Modal(glossaryModal);
        bsModal.show();

      } catch (error) {
        console.error('Error parsing JSON:', error);
      }
    }
}

document.addEventListener("DOMContentLoaded", function() {
    // Select all elements that should trigger the Glossary/Modal
    let glossaryTriggers = document.querySelectorAll('.glossary');
  
    glossaryTriggers.forEach(function(trigger) {
      trigger.addEventListener('click', function(event) {
        event.preventDefault();  // Prevent default link behavior if necessary
  
        // Instantiate Glossary with the clicked element
        new Glossary(event.currentTarget);
      });
    });
  });

// let glossaryModal = document.getElementById("glossaryModal");
// if (glossaryModal != null) {
//   glossaryModal.addEventListener("show.bs.modal", function (e) {

//     new Glossary(e);
//   });
// } else {
//   Glossary = null;
// }
